import * as angular from 'angular';
import {IController} from "angular";
import {$agentsFactory} from "../../$agents.factory";
import {AgentStatusType} from "../../types/agentStatus.type";

export class AgentsActionFooterComponent implements IController {
  ids: string[];
  selectedCount: number;
  onAskToEnableGps: Function;
  onAskToEnableGpsPermissions: Function;
  onAskToClockIn: Function;
  onBulkEdit: Function;
  onClear: Function;

  public agentsRef;
  public agents;
  public agentStatusTypes: typeof AgentStatusType = AgentStatusType;
  public allowBulkClockInAction: boolean;

  constructor(private $agents: $agentsFactory) {
    this.agentsRef = this.$agents();
  }

  $onInit() {
    this.setAgents();
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setAgents();
    }
  }


  private setAgents() {
    this.agents = [];

    if (!this.ids?.length) {
      this.allowBulkClockInAction = true;
      return;
    }
    this.agentsRef.$asyncValues(this.ids)
      .then((agents) => {
        this.agents = agents;
        this.allowBulkClockInAction = !this.agents.filter(a => a.status === this.agentStatusTypes.OnDuty || a.status === this.agentStatusTypes.OnDutyOnBreak).length
      })
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentsActionFooter', {
    bindings: {
      ids: '<',
      selectedCount: '<',
      onAskToEnableGps: '&',
      onAskToEnableGpsPermissions: '&',
      onAskToClockIn: '&',
      onBulkEdit: '&',
      onClear: '&'
    },
    template: require('./agents-action-footer.html').default,
    controller: AgentsActionFooterComponent
  });
